import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'id',
        type: 'number',
    },
    {
        key: 'DCIX_PROVIDER_ID',
        label: 'idDcix',
        type: 'number',
    },
    {
        key: 'COMPANY_NAME',
        label: 'eshopName',
    },
    {
        key: 'WEBSITE',
        label: 'website',
    },
    {
        key: 'PROVIDER_EMAIL',
        label: 'email',
    },
    {
        key: 'ACTIVE',
        label: 'active',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
];

export const waitingColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'id',
        type: 'number',
    },
    {
        key: 'PROVIDER_NAME',
        label: 'eshopName',
    },
];
